module.exports = __webpack_public_path__ + "static/media/Helvetica.c16874a1.otf";